<template>
  <b-modal
    ref="modal"
    centered
    class="decline-rent-form modal-confirmation text-center p-3"
    hide-footer
    static
    :size="currentStep === steps['verify'].value ? 'md' : 'lg'"
    @shown="onShow"
    @hidden="onShow"
  >
    <b-img
      slot="modal-header-close"
      :src="require('@/assets/icons/x-b.svg')"
      width="45"
      height="30"
    ></b-img>

    <div
      v-if="currentStep === steps['verify'].value"
      class="d-flex flex-column justify-content-between align-items-center text-center"
    >
      <b-img
        :src="require('@/assets/images/alert.svg')"
        width="150"
        height="150"
        class="modal-confirmation__icon"
      ></b-img>

      <h2>Decline request</h2>

      <b-card>
        <div class="rent-detail d-flex flex-row">
          <b-avatar :src="avatar" size="60px" class="mr-4"></b-avatar>
          <div class="d-flex flex-column justify-content-center">
            <div class="text-left">
              <h5 v-if="notification">{{ notification.message }}</h5>
              <p>{{ tool.name }}</p>
            </div>
            <div class="notification-date d-flex flex-row align-items-center">
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/calendar.svg')"
              ></b-img>
              <label>{{ from }}</label>
              <b-img
                width="15"
                class="notification-icon"
                :src="require('@/assets/icons/arrow-right-tail-b.svg')"
              ></b-img>
              <label>{{ to }}</label>
            </div>
          </div>
        </div>
      </b-card>

      <p class="my-4">
        Are you sure you want to decline the request?
      </p>
      <div class="modal-confirmation__footer">
        <b-button variant="outline-secondary" @click="close()">Cancel</b-button>
        <b-button variant="danger" @click="nextStep">
          <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;Decline
        </b-button>
      </div>
    </div>
    <b-form v-else class="rent-reason text-left" @submit.prevent="nextStep">
      <h3>Why did you decline this request?</h3>
      <ul>
        <li>
          <input type="radio" v-model="option" :value="0" id="reason-1" /><label
            for="reason-1"
          ></label>
          Reason #1 - Lorem ipsum dolor sit amet, consectetur adipisicing elit
        </li>
        <li>
          <input type="radio" v-model="option" :value="1" id="reason-2" /><label
            for="reason-2"
          ></label>
          Reason #2 - Ut enim ad minim veniam, quis nostrud exercitation ullamco
          laboris nisi
        </li>
        <li>
          <input type="radio" v-model="option" :value="2" id="reason-3" /><label
            for="reason-3"
          ></label>
          Reason #3 - Duis aute irure dolor in reprehenderit in voluptate velit
          esse cillum
        </li>
        <li>
          <input type="radio" v-model="option" :value="3" id="reason-4" /><label
            for="reason-4"
          ></label>
          <custom-input
            v-model="otherReason"
            placeholder="Other (Write your reason)"
            :required="onOthers"
            :disabled="form.$busy"
            :is-invalid="form.$getError('reason')"
          ></custom-input>
        </li>
        <error-message
          sign=""
          :error="form.$getError('reason') || form.$errorMessage"
        ></error-message>
      </ul>
      <div
        class="modal-confirmation__footer modal-confirmation__footer--normal modal-confirmation__footer--single"
      >
        <b-button type="submit" block variant="primary" :disabled="form.$busy">
          <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;Send
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
<script>
/**
 * ==================================================================================
 * Decline rent request form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import Notification from '@/models/Notification'
import CustomInput from '@/components/inputs/CustomInput'
import ErrorMessage from '@/components/inputs/ErrorMessage'

export default {
  components: {
    CustomInput,
    ErrorMessage
  },
  props: {
    notification: {
      type: [Notification, Object]
    }
  },
  computed: {
    actor() {
      return this.notification && this.notification.actor
        ? this.notification.actor
        : null
    },

    avatar() {
      if (!this.actor) return
      return (
        this.actor.avatar_permanent_thumb_url || this.actor.avatar_permanent_url
      )
    },

    tool() {
      return this.rent && this.rent.tool ? this.rent.tool : {}
    },

    rent() {
      return this.notification && this.notification.rent_request
        ? this.notification.rent_request
        : {}
    },

    from() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.from, 'DD/MM/YYYY')
    },
    to() {
      if (!this.rent) return 'NA'
      return this.parseDate(this.rent.to, 'DD/MM/YYYY')
    },

    onOthers() {
      return this.option === 3
    }
  },
  data: function() {
    return {
      option: 0,
      otherReason: null,
      reasons: [
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit',
        'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
        'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum'
      ],
      form: new Form({
        reason: null
      }),

      currentStep: null,
      steps: {
        verify: {
          value: 1
        },
        reason: {
          value: 2
        }
      }
    }
  },
  methods: {
    ...mapActions({
      declineRequest: 'notification/declineRequest',
      addAlert: 'alert/addAlert'
    }),
    nextStep() {
      switch (this.currentStep) {
        case this.steps['verify'].value:
          this.setStep(this.steps['reason'])
          break
        case this.steps['reason'].value:
          this.onConfirmation()
          break
      }
    },

    async onConfirmation() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      this.addAlert({
        state: true,
        label: 'Declining rent request...',
        countdown: true
      })

      await this.declineRequest({
        id: this.rent.renter_code,
        reason: this.onOthers ? this.otherReason : this.reasons[this.option]
      })
        .then(data => {
          this.form.$setLoading(false)
          this.addAlert({
            label: 'Request has been declined'
          })

          this.close()
          this.$emit('declined', data.data.data)
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.addAlert({
            state: false,
            label: this.form.$errorMessage
          })

          this.close()
        })
    },

    onShow() {
      this.option = 0
      this.form.$errorMessage = ''
      this.setStep(this.steps['verify'])
    },

    setStep(obj) {
      this.currentStep = obj.value
    },

    show() {
      this.$refs.modal.show()
    },

    close() {
      this.$refs.modal.hide()
    }
  },

  created() {
    this.onShow()
  }
}
</script>
<style lang="scss" scoped>
.decline-rent-form {
  h2 {
    margin-bottom: 40px;
  }

  .modal-confirmation__icon {
    margin: 0 auto;
  }

  .card {
    border: 1px solid #ededed;
    box-shadow: 0px 6px 12px #00000008;
    margin-bottom: 20px;

    .card-body {
      padding: 1rem 1.75rem;
    }

    .notification-date {
      margin-top: 2.5px;

      label {
        margin-bottom: 0;
      }

      > * {
        margin-right: 10px;
      }
    }

    .rent-detail {
      h5,
      p {
        margin-bottom: 0;
      }

      h5 {
        font-weight: 600;
      }
    }
  }

  .rent-reason {
    h3 {
      margin-top: 30px;
    }

    ul {
      padding: 0;
      margin: 50px 0;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 17.5px;

        input[type='radio'] + label {
          margin-right: 10px;
        }

        .custom-input {
          width: 100%;
          max-width: 500px;
        }
      }
    }

    .btn {
      width: 80%;
    }
  }
}
</style>
